import React from 'react';
import { cn } from '@/lib/utils';

export interface ContestMetaStatProps {
  label: string;
  value: React.ReactNode;
  valueClassName?: string;
  className?: string;
}

/** Label + value pair used on contest cards (Figma Contest Information). */
export function ContestMetaStat({
  label,
  value,
  valueClassName = 'text-white',
  className,
}: ContestMetaStatProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 whitespace-nowrap font-sans text-label-sm capitalize',
        className
      )}
    >
      <span className="font-normal text-muted-foreground">{label}</span>
      <span className={cn('font-semibold', valueClassName)}>{value}</span>
    </div>
  );
}
